// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"6821e1e8","246":"23a6d603","458":"1f5b4b2d","459":"4df54df1","707":"e0a72ecb","774":"58739ca2","858":"a7f29f58"}[chunkId] + ".chunk.js";
};